import 'jquery-ui/ui/widgets/datepicker';
// const $ = jQuery.noConflict();

$(document).ready(function () {
    $(".datepicker" ).datepicker({
        dateFormat: 'dd/mm/yy',
        showOtherMonths: true,
        minDate: "today",
        onSelect : function () {
            $(document).trigger('datepickerSelected', $(this));
            $(this).addClass("filled").parents(".form-group").addClass("focused")
        }
    });

})